import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
const CreateDossierCybilleController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierCybilleController.url(args, options),
    method: 'post',
})

CreateDossierCybilleController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/cybille',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
CreateDossierCybilleController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return CreateDossierCybilleController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierCybilleController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierCybilleController.php
* @route '/api/dossier/{dossier}/cybille'
*/
CreateDossierCybilleController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierCybilleController.url(args, options),
    method: 'post',
})

export default CreateDossierCybilleController